// extracted by mini-css-extract-plugin
export default {"homeHeader":"Location_homeHeader__kT45E"};